import { Tag } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { FecAccountMappingStatus } from '../../../../../../enums/fecAccountMappingStatus'

const STATUS_TRANSLATION_KEYS: Record<FecAccountMappingStatus, string> = {
  [FecAccountMappingStatus.Existing]:
    'settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.status.existing',
  [FecAccountMappingStatus.New]:
    'settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.status.new',
}

interface AccountStatusBadgeProps {
  status: FecAccountMappingStatus
}

export const AccountStatusBadge = ({ status }: AccountStatusBadgeProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Tag
      color={status === FecAccountMappingStatus.Existing ? 'neutral' : 'blue'}
      label={t(STATUS_TRANSLATION_KEYS[status])}
      size="small"
      type="subtle"
    />
  )
}
